import { useId } from "react";

interface SparklineProps {
  data: number[];
  color?: string;
  height?: number;
  fill?: boolean;
}

/** Hand-rolled SVG area sparkline (extracted from MetricsView's AreaChart).
 *  Scales 0..max over the full width; safe with short/empty data. */
export function Sparkline({ data, color = "var(--accent)", height = 90, fill = true }: SparklineProps) {
  // useId() emits ":r1:"-style ids; colons are unsafe inside url(#…) refs.
  const id = `spark-${useId().replace(/:/g, "")}`;
  const w = 320, h = height;
  if (data.length < 2) {
    return <svg viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" style={{ width: "100%", height }} />;
  }
  const max = Math.max(...data, 1);
  const min = 0;
  const range = Math.max(max - min, 1);
  const step = w / (data.length - 1);
  const pts = data.map((v, i) => `${(i * step).toFixed(1)},${(h - ((v - min) / range) * h).toFixed(1)}`);
  return (
    <svg viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" style={{ width: "100%", height }}>
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.35" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      {fill && <path d={`M0,${h} L${pts.join(" L")} L${w},${h} Z`} fill={`url(#${id})`} />}
      <polyline points={pts.join(" ")} fill="none" stroke={color} strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
